module.exports = __webpack_public_path__ + "static/media/ic_p6off.56e31154.png";